<template>
  <!--begin::Wrapper container-->
  <div class="app-container container-xxl">
    <!--begin::Main-->
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
      <!--begin::Content wrapper-->
      <div class="d-flex flex-column flex-column-fluid">
        <!--begin::Content-->
        <div id="kt_app_content" class="app-content ">
          <!--begin::About card-->
          <div class="card" v-if="settings">     
            <!--begin::Body-->
            <div class="card-body">
              <div class="carousel row d-flex" v-if="categories.length <= 10">
                <div v-for="(category, key) in categories" :key="key" class="carouselslide">
                  <div class="slide symbol symbol-fixed position-relative" style="width: 100%; height: 170px; text-align: center;" @click="searchCat(category.id)">
                    <span class="img" :style="`background-image: url(${category.image});`" v-if="category.image"></span>
                    <span class="img" :style="`background-image: url(https://picsum.photos/400?random=${category.id});`" v-else></span>
                    <div class="mt-5">
                        <h5 v-if="this.$i18n.locale == 'nl'">{{ category.name }}</h5>
                        <h5 v-if="this.$i18n.locale == 'fr'">{{ category.name_fr }}</h5>
                        <h5 v-if="this.$i18n.locale == 'en'">{{ category.name_en }}</h5>
                    </div>
                  </div>
                </div>
              </div>

              <carousel :itemsToShow="5" :wrapAround="true" :dots="false" :breakpoints="breakpoints" v-else>
                <slide v-for="(category, key) in categories" :key="key">
                  <div class="slide symbol symbol-fixed position-relative" style="width: 100%; height: 150px; text-align: center;" @click="searchCat(category.id)">
                    <span class="img" :style="`background-image: url(${category.image});`" v-if="category.image"></span>
                    <span class="img" :style="`background-image: url(https://picsum.photos/400?random=${category.id});`" v-else></span>
                    <div class="mt-5">
                        <h5 v-if="this.$i18n.locale == 'nl'">{{ category.name }}</h5>
                        <h5 v-if="this.$i18n.locale == 'fr'">{{ category.name_fr }}</h5>
                        <h5 v-if="this.$i18n.locale == 'en'">{{ category.name_en }}</h5>
                    </div>
                  </div>
                </slide>

                <template #addons>
                  <navigation />
                </template>
              </carousel>

              <div class="row mt-10" v-if="languages && settings.show_language.id == 1 || settings.show_slider.id == 1">
                <div class="col-lg-6" v-if="languages && settings.show_language.id == 1">
                  <a style="float: left; margin-right: 10px;" v-for="(language, key) in languages" :key="key" @click="searchLang(language.id)">
                    <span v-if="search.language == language.id" class="btn btn-success">
                      <span v-if="this.$i18n.locale == 'nl'">{{ language.language }}</span>
                      <span v-if="this.$i18n.locale == 'fr'">{{ language.language_fr }}</span>
                      <span v-if="this.$i18n.locale == 'en'">{{ language.language_en }}</span>
                    </span>
                    <span v-else class="btn btn-secondary">
                      <span v-if="this.$i18n.locale == 'nl'">{{ language.language }}</span>
                      <span v-if="this.$i18n.locale == 'fr'">{{ language.language_fr }}</span>
                      <span v-if="this.$i18n.locale == 'en'">{{ language.language_en }}</span>
                    </span>
                  </a>
                </div>

                <div class="col-lg-6" v-if="settings.show_slider.id == 1">
                  <p class="font-medium text-gray-500 leading-6" style="color: #403d70; font-weight: bold; text-align: center; top: 55px; position: relative;"> {{ $t('price_range') }}/{{dynamicPricingLabel}} </p>
                  <RangeSlider :max="1000" v-model:min-value="minValue" v-model:max-value="maxValue" />
                </div>
              </div>

              <div class="search row mt-10">
                <div class="col-lg-12">
                  <input class="form-control form-control-sm form-control-solid" v-model="searchTerm" @keyup="handleKeyup" @click="handleReset" style="font-size: 16px; padding: 10px 20px; width: 100%;" :placeholder="$t('search_here')"/>

                  <div class="lds-facebook" v-if="searching==1"><div></div><div></div><div></div></div>
                </div>

                <ul style="height: 60px; margin-top: 20px;" v-if="subcatssearch && subcatssearch.length">
                  <li style="float: left; margin: 0px 10px 15px 0px; padding-bottom: 10px; list-style: none;" v-for="(category, key) in subcatssearch" :key="key" @click="searchCat(category.id)">
                      <span v-if="search.category == category.id" style="margin-bottom: 10px; cursor: pointer; -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); padding: 10px 20px; border-radius: 20px; color: rgb(241, 245, 249); background: rgb(64, 61, 112) !important; font-size: 14px; font-weight: bold;">
                        <span v-if="this.$i18n.locale == 'nl'">{{ category.name }}</span>
                        <span v-if="this.$i18n.locale == 'fr'">{{ category.name_fr }}</span>
                        <span v-if="this.$i18n.locale == 'en'">{{ category.name_en }}</span>
                      </span>
                      <span v-else style="margin-bottom: 10px; cursor: pointer; -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); padding: 10px 20px; border-radius: 20px; background: rgb(241, 245, 249); color: rgb(64, 61, 112) !important; font-size: 14px; font-weight: bold;">
                        <span v-if="this.$i18n.locale == 'nl'">{{ category.name }}</span>
                        <span v-if="this.$i18n.locale == 'fr'">{{ category.name_fr }}</span>
                        <span v-if="this.$i18n.locale == 'en'">{{ category.name_en }}</span>
                      </span>
                  </li>
                </ul>

                <a href="/" v-if="searched" style="position: relative; top: 20px; color: #ff3665; font-weight: bold;">{{ $t('clear_filters') }}</a>
              </div>

              <div class="speakers mt-10" v-if="experts">
                <div class="row gx-6 gx-xl-9">
                  <strong v-if="experts.length == 0">{{ $t('no_assets_found', { assets: dynamicAssetsLabel.toLowerCase() }) }}</strong>

                  <div class="col-lg-3 col-xxl-3 mt-10" v-for="(expert, key) in experts" :key="key">
                    <a :href="`/expert/${slugify(expert.title)}/${expert.id}`" class="uk-link-reset">
                      <!--begin::Card-->
                      <div class="card h-100" style="border: 1px solid #f1f1f4; box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);">
                        <!--begin::Card body-->
                        <div class="card-body" style="padding: 0px;">
                            <span v-if="expert.featured" style="position: absolute; top: 10px; padding: 5px 15px; background: #1409a0; color: #fff; font-weight: bold; font-size: 12px; border-top-right-radius: 20px; border-bottom-right-radius: 20px;">{{dynamicFeaturedLabel}}</span>
                            <!--begin::Heading-->
                            <div class="profimage" :style="`background-image: url(${expert.image});`" v-if="expert.image"></div>
                            <div class="profimage" :style="`background-image: url(https://picsum.photos/400?random=${expert.id});`" v-else></div>

                            <div class="p-9">
                              <h4>{{ expert.title }}</h4>
                              <div class="fs-6 fw-semibold text-gray-500 mb-7" v-if="this.$i18n.locale == 'nl'">{{ sanitizedDescription(expert.description) }}</div>
                              <div class="fs-6 fw-semibold text-gray-500 mb-7" v-if="this.$i18n.locale == 'fr'">{{ sanitizedDescription(expert.description_fr) }}</div>
                              <div class="fs-6 fw-semibold text-gray-500 mb-7" v-if="this.$i18n.locale == 'en'">{{ sanitizedDescription(expert.description_en) }}</div>

                              <div class="text-lg font-semibold" style="margin-top: 20px; margin-bottom: 10px; min-height: 25px;" v-if="settings.show_pricing.id == 1">
                                <span v-if="expert.price == 0">&nbsp;</span>
                                <span v-else class="btn btn-light-primary" style="bottom: 20px; position: absolute;">&euro; {{expert.markup_price/100}}/{{dynamicPricingLabel}}</span>
                              </div>
                            </div>
                            <!--end::Heading-->
                        </div>
                        <!--end::Card body-->
                      </div>
                      <!--end::Card-->
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!--end::Body-->
          </div>
          <!--end::About card-->
        </div>
        <!--end::Content-->	
      </div>
      <!--end::Content wrapper-->
    </div>
    <!--end:::Main-->
  </div>
</template>

<style>
  .catsslider img {
    filter: brightness(0.8);
  }
  
  .catsslider img:hover {
    filter: brightness(1);
  }
</style>

<script>
  import axios from 'axios';
  import RangeSlider from "../_shared/RangeSlider.vue";
  import 'vue3-carousel/dist/carousel.css'
  import { Carousel, Slide, Navigation } from 'vue3-carousel'

  export default {
    components: {
      RangeSlider,
      Carousel,
      Slide,
      Navigation,
    },
    data() {
      return {
        searched: false,
        experts: null,
        minValue: 0,
        maxValue: 0,
        categories: null,
        feedback: null,
        searchTerm: '',
        subcats: null,
        subcatssearch: null,
        timestamp: 0,
        searching: 0,
        search: {
          category: '',
          language: ''
        },
        search_id: null,
        settings: null,
        breakpoints: {
          // 700px and up
          450: {
            itemsToShow: 2,
            snapAlign: 'start',
          },
          // 700px and up
          700: {
            itemsToShow: 3,
            snapAlign: 'start',
          },
          // 1024 and up
          1024: {
            itemsToShow: 5,
            snapAlign: 'start',
          },
        },
      };
    },
    watch: {
      minValue(newValue, oldValue) {
        // Clear any previous timeouts
        clearTimeout(this.minValueTimeout);

        // Set a new timeout to watch for changes after 2000 milliseconds (2 seconds)
        this.minValueTimeout = setTimeout(() => {
          // Do something when minValue hasn't changed for 2 seconds
          console.log("minValue hasn't changed for 2 seconds");
          console.log(newValue);
          console.log(oldValue);

          this.handleSearch();
        }, 2000);
      },
      maxValue(newValue, oldValue) {
        // Clear any previous timeouts
        clearTimeout(this.maxValueTimeout);

        // Set a new timeout to watch for changes after 2000 milliseconds (2 seconds)
        this.maxValueTimeout = setTimeout(() => {
          // Do something when minValue hasn't changed for 2 seconds
          console.log("maxValue hasn't changed for 2 seconds");
          console.log(newValue);
          console.log(oldValue);

          this.handleSearch();
        }, 2000);
      },
    },
    computed: {
      dynamicPricingLabel() {
        const currentLocale = this.$i18n.locale;
        // You can adjust this logic as needed to handle different locale suffixes
        switch (currentLocale) {
          case 'fr':
            return this.settings.asset_label_pricing_fr;
          case 'en':
            return this.settings.asset_label_pricing_en;
          default:
            return this.settings.asset_label_pricing; // Default key for other locales
        }
      },
      dynamicFeaturedLabel() {
        const currentLocale = this.$i18n.locale;
        // You can adjust this logic as needed to handle different locale suffixes
        switch (currentLocale) {
          case 'fr':
            return this.settings.asset_label_featured_fr;
          case 'en':
            return this.settings.asset_label_featured_en;
          default:
            return this.settings.asset_label_featured; // Default key for other locales
        }
      },
      dynamicAssetLabel() {
        const currentLocale = this.$i18n.locale;
        // You can adjust this logic as needed to handle different locale suffixes
        switch (currentLocale) {
          case 'fr':
            return this.settings.asset_label_single_fr;
          case 'en':
            return this.settings.asset_label_single_en;
          default:
            return this.settings.asset_label_single; // Default key for other locales
        }
      },
      dynamicAssetsLabel() {
        const currentLocale = this.$i18n.locale;
        // You can adjust this logic as needed to handle different locale suffixes
        switch (currentLocale) {
          case 'fr':
            return this.settings.asset_label_double_fr;
          case 'en':
            return this.settings.asset_label_double_en;
          default:
            return this.settings.asset_label_double; // Default key for other locales
        }
      },
    },
    methods: {
      sanitizedDescription(desc) {
        // Get the expert's description
        const description = desc;

        if(description) {
          // Use a regular expression to remove HTML tags
          var sanitized = description.replace(/<[^>]+>/g, '');

          var entities = [
              ['amp', '&'],
              ['eacute', 'é'],
              ['ndash', '-'],
              ['apos', '\''],
              ['#x27', '\''],
              ['#x2F', '/'],
              ['#39', '\''],
              ['#47', '/'],
              ['lt', '<'],
              ['gt', '>'],
              ['nbsp', ' '],
              ['quot', '"']
          ];

          for (var i = 0, max = entities.length; i < max; ++i) {
            sanitized = sanitized.replace(new RegExp('&' + entities[i][0] + ';', 'g'), entities[i][1]);
          }

          // Check if the sanitized text is longer than 250 characters
          if (sanitized.length > 250) {
            // Truncate the sanitized text to 250 characters and add ellipsis
            return sanitized.slice(0, 250) + '...';
          }
        } else {
          return '';
        }
      },
      thumbs(type) {
        var token = localStorage.getItem('xperttoken');
        var customerselected = localStorage.getItem('xpertcustomerselected');

        if(!token) {
          token = this.$token;
        }

        // Set the authorization header with the bearer token
        const instance = axios.create({
            baseURL: this.$baseURL,
            headers: {
              Authorization: `Bearer ${token}`,
              'Customer': customerselected,
            }
        });

        instance.get('/eden/search/'+this.search_id+'/thumbs/'+type)
        .then(response => {
          console.log(response);

          this.search_id = null;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
      },
      slugify(text) {
        return text
          .toString()
          .toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(/[^\w-]+/g, '') // Remove all non-word characters
          .replace(/--+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, ''); // Trim - from end of text
      },
      getNow() {
        const today = new Date();
        const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const dateTime = date +' '+ time;
        this.timestamp = dateTime;
      },
      searchCat(catId) {
        if(this.search.category == catId) {
          this.search.category = '';
        } else {
          this.search.category = catId;
        }

        this.searchTerm = '';

        this.handleSearch();
      },
      searchLang(languageId) {
        if(this.search.language == languageId) {
          this.search.language = '';
        } else {
          this.search.language = languageId;
        }

        this.handleSearch();
      },
      handleReset() {
        //this.searchTerm = '';
      },
      handleSearch() {
        var token = localStorage.getItem('xperttoken');
        var customerselected = localStorage.getItem('xpertcustomerselected');

        if(!token) {
          token = this.$token;
        }

        this.searched = true;

        // Set the authorization header with the bearer token
        const instance = axios.create({
            baseURL: this.$baseURL,
            headers: {
              Authorization: `Bearer ${token}`,
              'Customer': customerselected,
            }
        });
        
        this.getNow();

        instance.get('/assets/search?category='+this.search.category+'&language='+this.search.language+'&time='+this.timestamp+'&start='+this.minValue+'&end='+this.maxValue)
        .then(response => {
          console.log(response);
          this.experts = response.data.assets;
          this.subcats = response.data.categories;
          this.subcatssearch = response.data.categories;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
      },
      handleKeyup() {
        // Clear the previous timeout
        clearTimeout(this.timeoutId);

        // Set a new timeout for 1000 milliseconds (1 second)
        this.timeoutId = setTimeout(() => {
            // Update the variable after the delay
            this.doSearch();
        }, 1000);
      },
      doSearch() {
        this.searching = 1;

        var token = localStorage.getItem('xperttoken');
        var customerselected = localStorage.getItem('xpertcustomerselected');

        if(!token) {
          token = this.$token;
        }

        // Set the authorization header with the bearer token
        const instance = axios.create({
            baseURL: this.$baseURL,
            headers: {
              Authorization: `Bearer ${token}`,
              'Customer': customerselected,
            }
        });
        
        this.getNow();

        instance.get('/eden/search?question='+this.searchTerm+'&time='+this.timestamp+'&start='+this.minValue+'&end='+this.maxValue)
        .then(response => {
          this.experts = response.data.assets;
          this.subcatssearch = response.data.categories;
          this.feedback = response.data.feedback;
          this.searching = 0;
          this.search_id = response.data.search.id;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
      },
      updateMinValue(newValue) {
        // Update the min value in the parent component
        this.minValue = newValue;

        this.handleSearch();
      },
      updateMaxValue(newValue) {
        // Update the max value in the parent component
        this.maxValue = newValue;

        this.handleSearch();
      },
    },
    mounted() {
      var token = localStorage.getItem('xperttoken');
      var customerselected = localStorage.getItem('xpertcustomerselected');

      if(!token) {
        token = this.$token;
      }
      
      // Set the authorization header with the bearer token
      const instance = axios.create({
        baseURL: this.$baseURL,
        headers: {
          Authorization: `Bearer ${token}`,
          'Customer': customerselected,
        }
      });
      
      instance.get('/admin/settings')
      .then(response => {
        console.log(response);

        this.settings = response.data.settings;
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        // Handle the error
      });

      instance.get('/assets')
        .then(response => {
          console.log(response);
          this.experts = response.data.assets;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });

      instance.get('/assets/languages')
        .then(response => {
          console.log(response);
          this.languages = response.data.languages;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });

      instance.get('/assets/categories/top')
        .then(response => {
          console.log(response);
          this.categories = response.data.categories;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });

        //assets/search?term=How do I grow my business online?
    },
  };
</script>